import React, { Component } from 'react';
import './Confirm.css';

class Confirm extends Component {
	render() {
		return <button className="confirm" onClick={this.props.action} />;
	}
}

export { Confirm };



// WEBPACK FOOTER //
// ./src/components/buttons/confirm/Confirm.js